import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-operadora',
  templateUrl: './home-operadora.component.html',
  styleUrls: ['./home-operadora.component.scss']
})
export class HomeOperadoraComponent implements OnInit {

  data = [
    { label: "Vendas Online", value: 40, color: "#ff6384" },
    { label: "Loja Física", value: 35, color: "#36a2eb" },
    { label: "Distribuidores", value: 25, color: "#ffce56" }
  ];

  slices: any[] = [];

  constructor() {
    
   }

  ngOnInit() {
    this.generatePieChart();
  }

  generatePieChart() {
    let startPercent = 0;

    this.slices = this.data.map(segment => {
      const percent = segment.value / 100;
      const [startX, startY] = this.getCoordinates(startPercent);
      const [endX, endY] = this.getCoordinates(startPercent + percent);
      const largeArc = percent > 0.5 ? 1 : 0;

      const pathData = `
        M 16 16
        L ${16 + startX * 16} ${16 + startY * 16}
        A 16 16 0 ${largeArc} 1 ${16 + endX * 16} ${16 + endY * 16}
        Z
      `;

      startPercent += percent;

      return {
        d: pathData,
        color: segment.color,
        label: segment.label,
        value: segment.value
      };
    });
  }

  getCoordinates(percent: number) {
    const x = Math.cos(2 * Math.PI * percent);
    const y = Math.sin(2 * Math.PI * percent);
    return [x, y];
  }

}
